class CMainPage {
	constructor() {

	}
}

module.exports = CMainPage;
